// Validation rules and messages carried over unchanged from the approved HTML.

export const FIELD_ORDER = [
  'name',
  'mobile',
  'email',
  'category',
  'district',
  'pin',
  'locality',
  'need',
  'consent',
];

export const ERROR_MESSAGES = {
  name: 'Please enter your name.',
  mobile: 'Please enter a valid 10-digit mobile number.',
  email: 'Please enter a valid email address.',
  category: 'Please choose one.',
  district: 'Please select your district.',
  pin: 'Please enter a valid 6-digit PIN code.',
  locality: 'Please tell us where your premises are.',
  need: 'Please choose one.',
  consent: 'Please give your consent so that we can send you updates.',
};

const RULES = {
  name: (d) => (d.name || '').trim().length >= 2,
  mobile: (d) => /^[6-9]\d{9}$/.test((d.mobile || '').trim()),
  email: (d) => !d.email || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(d.email.trim()),
  category: (d) => !!d.category,
  district: (d) => !!d.district,
  pin: (d) => /^\d{6}$/.test((d.pin || '').trim()),
  locality: (d) => (d.locality || '').trim().length >= 2,
  need: (d) => !!d.need,
  consent: (d) => d.consent === true,
};

/** Returns a map of field name -> true for every invalid field. */
export function validate(values) {
  const errors = {};
  for (const field of FIELD_ORDER) {
    if (!RULES[field](values)) errors[field] = true;
  }
  return errors;
}
